import userCenter from '@/constants/userCenter';
import errorCode from '@/constants/errorCode';
import { IUserLoginInfo } from '@/api/user';
import { handleWindow } from '@/utils/common';

const handleToUserCenter = (code: number, backUrl = handleWindow().location.href) => {
  const {
    login,
    bindPhone
  } = userCenter(backUrl);
  if (code === errorCode.UNAUTHORIZED) {
    return login;
  } else if (code === errorCode.UNBIND_PHONE) {
    return bindPhone;
  }

  return login;

}

type QueryParamValue = string | string[] | undefined;

export const hasUserCenterAuthCookie = (cookie?: string) => {
  const cookieStr = String(cookie || '');
  const hasMetaKey = /(?:^|;\s*)_meta_key=/.test(cookieStr);
  const hasAuth = /(?:^|;\s*)H5VF_2132_auth=/.test(cookieStr);
  const hasSalt = /(?:^|;\s*)H5VF_2132_saltkey=/.test(cookieStr);
  return hasMetaKey || (hasAuth && hasSalt);
};

export const parseUidFromQuery = (rawUid?: QueryParamValue) => {
  if (typeof rawUid === 'string') {
    return Number(rawUid);
  }
  if (Array.isArray(rawUid)) {
    return Number(rawUid[0]);
  }
  return NaN;
};

export const parseUuidFromQuery = (rawUuid?: QueryParamValue) => {
  if (typeof rawUuid === 'string') {
    return rawUuid;
  }
  if (Array.isArray(rawUuid)) {
    return rawUuid[0] || '';
  }
  return '';
};

export const resolveUidAndUuid = ({
  rawUid,
  rawUuid,
  account,
}: {
  rawUid?: QueryParamValue;
  rawUuid?: QueryParamValue;
  account?: IUserLoginInfo | null;
}) => {
  let uid = parseUidFromQuery(rawUid);
  let uuid = parseUuidFromQuery(rawUuid);

  if (!Number.isFinite(uid) && account) {
    uid = account.id;
  }

  if (!uuid && account?.uuid) {
    uuid = account.uuid;
  }

  return { uid, uuid };
};

export const resolveReportUid = (uidFromQuery: number, accountId?: number) => {
  if (Number.isFinite(uidFromQuery)) {
    return uidFromQuery;
  }
  const normalizedAccountId = Number(accountId);
  return Number.isFinite(normalizedAccountId) ? normalizedAccountId : null;
};

const normalizeBooleanLike = (value: unknown) => {
  if (value === true || value === 'true' || value === 1 || value === '1') {
    return true;
  }
  return false;
};

export const resolveUserCenterCreditTip = (
  loginCreditAdded?: unknown,
  visitCreditAdded?: unknown
) => {
  const loginAdded = normalizeBooleanLike(loginCreditAdded);
  const visitAdded = normalizeBooleanLike(visitCreditAdded);
  if (loginAdded && visitAdded) {
    return '每天登录，访问别人空间，积分+6';
  }
  if (loginAdded && !visitAdded) {
    return '每天登录，积分+5';
  }
  if (!loginAdded && visitAdded) {
    return '访问别人空间，积分+1';
  }
  return '';
};

export default handleToUserCenter;
